import { baseRoutes } from "@/api/base-routes";
import { packNetAxios } from "@/lib/api-client";
import type { CartonPropertyGroup, CartonPropertyGroupConfiguration } from "@/schemas/carton-property-group";

// Re-export types for backward compatibility (remove later)
export type { CartonPropertyGroup, CartonPropertyGroupStatus } from "@/schemas/carton-property-group";

export async function getCartonPropertyGroups(): Promise<CartonPropertyGroup[]> {
	const response = await packNetAxios.get<CartonPropertyGroup[]>(`${baseRoutes.selection}/v1/cartonPropertyGroups`);

	return response.data;
}

export async function getCartonPropertyGroupNamesForProductionGroup(productionGroupId: string): Promise<string[]> {
	const response = await packNetAxios.get<string[]>(
		`${baseRoutes.selection}/v1/cartonPropertyGroups/names/byProductionGroup/${productionGroupId}`,
	);

	return response.data;
}

export function createCartonPropertyGroup(cartonPropertyGroup: CartonPropertyGroupConfiguration): Promise<void> {
	return packNetAxios.post(`${baseRoutes.selection}/v1/cartonPropertyGroups`, cartonPropertyGroup);
}

export async function updateCartonPropertyGroup(
	cartonPropertyGroup: CartonPropertyGroup,
): Promise<CartonPropertyGroup[]> {
	const response = await packNetAxios.put<CartonPropertyGroup[]>(
		`${baseRoutes.selection}/v1/cartonPropertyGroups/${cartonPropertyGroup.id}`,
		cartonPropertyGroup,
	);

	return response.data;
}

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.selection}/v1/version`);

	return response.data;
}

export function deleteCartonPropertyGroup(id: string): Promise<void> {
	return packNetAxios.delete(`${baseRoutes.selection}/v1/cartonPropertyGroups/${id}`);
}
